// @examforge/shared/i18n barrel.
//
// Consumers:
//   import { getDictionary, DEFAULT_LOCALE, type Locale, type DictionaryKey } from '@examforge/shared/i18n';
//   const dict = getDictionary('en');
//   const greeting = dict['common.save'];
//
// React-side wrapping (provider + useT hook) lives in packages/web/src/i18n/.
import { zh } from './zh.js';
import { en } from './en.js';
export { SUPPORTED_LOCALES, DEFAULT_LOCALE } from './dictionary.js';
export { zh } from './zh.js';
export { en } from './en.js';
const DICTIONARIES = { zh, en };
export function getDictionary(locale) {
    return DICTIONARIES[locale];
}
/** Strict lookup. Returns the value or, if the key is missing, the key itself
 *  (so a UI typo shows up as "form.steo1.title" instead of crashing). */
export function translate(locale, key) {
    const dict = DICTIONARIES[locale];
    return dict[key] ?? key;
}
/** Validate a string is a supported locale. Used at the localStorage boundary. */
export function isLocale(value) {
    return value === 'zh' || value === 'en';
}
//# sourceMappingURL=index.js.map